// extracted by mini-css-extract-plugin
export default {"trout":"#4a5161","mischka":"#d0d5dd","christine":"#e66609","crumb":"styles_crumb__pcUxd","link":"styles_link__NJC8R","current":"styles_current__ulNxj"};